import { useFallbackFooter } from '@interhyp/platform-layout';
import { Notification } from '@platform/elements';
import React from 'react';

import { Navbar } from '../../components/NavBar/Navbar';

export function MissingLogin(): React.JSX.Element {
  const fallback = useFallbackFooter();

  return (
    <>
      <Navbar />

      <div style={{ minHeight: 'calc(100vh - var(--navigation-height))' }}>
        <Notification type="error">
          Login aktuell nicht verfügbar. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.
        </Notification>
      </div>

      {fallback}
    </>
  );
}
